export enum ShipmentCreationType {
  OnlineBooking = 'ONLINE_BOOKING',
  Normal = 'NORMAL'
}
